/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Precheck_TitleInputs */



/**
* | output |
* | --- |
* | "Export Pre-Checks" |
*
* @param {Embed_Captions_Precheck_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_precheck_title = /** @type {((inputs?: Embed_Captions_Precheck_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Precheck_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pre-verifications d'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export-Vorabprüfungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controlli preliminari all'esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительные проверки при экспорте")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comprobaciones previas a la exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出口预检查")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートの事前チェック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात पूर्व-जांच")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verificações prévias para exportação")
	return /** @type {LocalizedString} */ ("Export Pre-Checks")
});